import { Button, DatePicker, Popconfirm, Select, Space, Table, Typography, Image, Empty, Spin } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DownloadOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import notificationHandler from "../../../atoms/Notification";
import kitchenAdmin from "../../../../apis/admin/kitchenService";
import report from "../../../../apis/admin/report";
import { API_BASE_URL } from "../../../../configs/apiClient";
import "./report.scss";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import { NO_IMAGE } from '../../../../configs/constant'
import { ColumnsType } from "antd/lib/table";

interface DataType {
  index: string;
  content: string;
  linkImage: string;
  action: string;
}

const SurveryReport = () => {
  const [date, setDate] = useState([]);
  const [dataReport, setDataReport] = useState<any>([]);
  const [ListKitchen, setListKitchen] = useState([]);
  const [kitchenId, setListKitchenId] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const [pageSize, setPageSize] = React.useState(10);

  const displayedIndex = (index: any) =>
    (currentPage - 1) * pageSize + index + 1;
  const { RangePicker } = DatePicker;

  dayjs.extend(customParseFormat);

  const dateFormat = "YYYY-MM-DD";
  const defaulttoDate: any = moment(dayjs("2023-05-01", dateFormat).toDate());
  const defaultformDate: any = moment(dayjs("2023-05-30", dateFormat).toDate());

  const { Title } = Typography;
  const antIcon = <LoadingOutlined style={{ fontSize: 70, position: 'fixed' }} spin />;

  useEffect(() => {
    kitchenAdmin
      .getKitchenData(1, "")
      .then((res: any) => {
        const data = res.data.data.payload;
        setListKitchen(data);
        
        const isOneOption = data?.length === 1;
        if (isOneOption) {
          setListKitchenId(data[0].id)
        }
      })
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      });
      setLoading(true)
    report
      .searchFeedbacks("", "", "", "" as any)
      .then((res: any) => {
        setDataReport(res.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", "Lỗi không tìm thấy dữ liệu");
      }).finally(() => setLoading(false));
  }, []);

  const onKitchenChange = (value: number) => {
    setListKitchenId(value);
  };

  const onchangeDate = (date: any, dateString: any) => {
    setDate(dateString);
  };

  const exportExcel = () => {
    let kitId = (kitchenId == undefined || kitchenId == 0) ? "" : kitchenId
    report
      .feedbacks("EXCEL", date[0] || "", date[1] || "", kitId as any)
      .then((res: any) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Đánh giá.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err: any) => {
        notificationHandler("error", "Xuất file exel không thành công");
      });
  };
  const handleSearch = () => {
    let kitId = (kitchenId == undefined || kitchenId == 0) ? "" : kitchenId
    report
      .searchFeedbacks("", date[0] || "", date[1] || "", kitId as any)
      .then((res: any) => {
        setDataReport(res.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", "Lỗi không tìm thấy dữ liệu");
        setDataReport(null);
      });
  };
  const paginationConfig = {
    showTotal: (total: any, range: any) =>
      `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
  };
  const columns: ColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      width: '5%',
      align: 'center',
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Nội dung đánh giá",
      dataIndex: "content",
      key: "content",
      ellipsis: true,
      align: 'center',
      width: '40%',
      render: (value: any, record: any, index: number) => {
        return (
          <div className="truncate" key={index} title={value}>{value}</div>
        )
      }
    },
    {
      title: "Ảnh đánh giá",
      dataIndex: "linkImage",
      key: "linkImage",
      width: '20%',
      align: 'center',
      render: (value: any, record: any, index: number) => {
        return (
          <div>
            { value ? <Image src="error" fallback={API_BASE_URL + value} alt="" width={150} height={150} /> : <Image src={NO_IMAGE} alt="" width={150} height={150} />}
          </div>
        );
      },
    },
  ];
  return (
    <div id="survery">
      <Spin indicator={antIcon} spinning={loading} />
      <div className="mb-5">
        <div className="flex justify-between">
          <div className="flex question-filter w-[70%]">
            <RangePicker
              onChange={onchangeDate}
              placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
              format={dateFormat}
              locale={locale}
              className="w-[30%] cursor-pointer"
            />

            <Select
              className="w-[20%] ml-3"
              placeholder="Chọn bếp ăn"
              onChange={onKitchenChange}
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input: string, option: any) => (option?.label.toLowerCase() ?? "").includes(input.trim().toLowerCase())}
              options={ListKitchen?.map((item: any, key: number) => ({
                value: item.id,
                label: item.kitchenName,
              }))}
              value={kitchenId}
            >
              {/* <Select.Option value=''>Chọn bếp ăn</Select.Option>
              {ListKitchen.map((item: any, key: number) => (
                <Select.Option key={key} value={item.id}>
                  {item.kitchenName}
                </Select.Option>
              ))} */}
            </Select>
            <Button
              icon={<SearchOutlined />}
              onClick={handleSearch}
              className="ml-3 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
            >
              Tìm kiếm
            </Button>
          </div>
          <Button
            shape="round"
            type="primary"
            className="bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
            icon={<DownloadOutlined />}
            onClick={exportExcel}
          >
            Xuất báo cáo
          </Button>
        </div>
      </div>
      <Title className='mt-[20px]' level={3}>Danh sách đánh giá</Title>
      <Table
        dataSource={dataReport}
        pagination={{
          locale: { items_per_page: "bản ghi / Trang" },
          current: currentPage,
          defaultPageSize: 10,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          onShowSizeChange(current, size) {
            setPageSize(size)
          },
          showTotal: (total: any, range: any) =>
            `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
        }}
        columns={columns}
        rowKey={(record: any) => record.id}
        className="mt-[15px]"
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description="Không có dữ liệu!" /> }}
      />
    </div>
  );
};

export default SurveryReport;
